import React from 'react';

export const PetsSvg: React.FunctionComponent = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.00004 7.99984C3.92052 7.99984 4.66671 7.25365 4.66671 6.33317C4.66671 5.4127 3.92052 4.6665 3.00004 4.6665C2.07957 4.6665 1.33337 5.4127 1.33337 6.33317C1.33337 7.25365 2.07957 7.99984 3.00004 7.99984Z"
      fill="#333333"
    />
    <path
      d="M6.00004 5.33333C6.92052 5.33333 7.66671 4.58714 7.66671 3.66667C7.66671 2.74619 6.92052 2 6.00004 2C5.07957 2 4.33337 2.74619 4.33337 3.66667C4.33337 4.58714 5.07957 5.33333 6.00004 5.33333Z"
      fill="#333333"
    />
    <path
      d="M10 5.33333C10.9205 5.33333 11.6667 4.58714 11.6667 3.66667C11.6667 2.74619 10.9205 2 10 2C9.07957 2 8.33337 2.74619 8.33337 3.66667C8.33337 4.58714 9.07957 5.33333 10 5.33333Z"
      fill="#333333"
    />
    <path
      d="M13 7.99984C13.9205 7.99984 14.6667 7.25365 14.6667 6.33317C14.6667 5.4127 13.9205 4.6665 13 4.6665C12.0796 4.6665 11.3334 5.4127 11.3334 6.33317C11.3334 7.25365 12.0796 7.99984 13 7.99984Z"
      fill="#333333"
    />
    <path
      d="M11.56 9.90667C10.98 9.22667 10.4933 8.64667 9.90668 7.96667C9.60001 7.60667 9.20668 7.24667 8.74001 7.08667C8.66668 7.06 8.59335 7.04 8.52001 7.02667C8.35335 7 8.17335 7 8.00001 7C7.82668 7 7.64668 7 7.47335 7.03333C7.40001 7.04667 7.32668 7.06667 7.25335 7.09333C6.78668 7.25333 6.40001 7.61333 6.08668 7.97333C5.50668 8.65333 5.02001 9.23333 4.43335 9.91333C3.56001 10.7867 2.48668 11.7533 2.68668 13.1067C2.88001 13.7867 3.36668 14.46 4.24001 14.6533C4.72668 14.7533 6.28001 14.36 7.93335 14.36H8.05335C9.70668 14.36 11.26 14.7467 11.7467 14.6533C12.62 14.46 13.1067 13.78 13.3 13.1067C13.5067 11.7467 12.4333 10.78 11.56 9.90667Z"
      fill="#333333"
    />
  </svg>
);
